import { AxiosError } from 'axios';
import { get as _get } from 'lodash';
import { parse, stringify } from 'qs';
import { Plugin } from 'vuex';
import { RootState } from '../store';

// redirects can retry if the first attempt fails (e.g. network blip).
let isRedirecting = false;

export const redirectToLoginSignup = (destination?: string) => {
  if (isRedirecting) return;
  isRedirecting = true;
  // Reset after 5s so it can retry if the redirect didn't actually navigate
  setTimeout(() => {
    isRedirecting = false;
  }, 5000);

  const query = parse(window.location.search);
  const { email } = query;
  const baseUrl = window.location.protocol + '//' + window.location.host;

  let finalDestination: string = '';
  if (destination) {
    finalDestination = `${baseUrl}${destination}`;
  } else {
    finalDestination = window.location.href;
  }

  console.log(`[JTA-1] redirectToLoginSignup destination: ${finalDestination}`);

  const loginQuery = stringify({
    destination: finalDestination,
    email
  });

  const loginUrl = `/login?${loginQuery}`;

  window.location.href = `${
    process.env.VUE_APP_BACKEND_HOSTNAME
  }/logout?destination=${encodeURIComponent(loginUrl)}`;
};

let isRedirectingToForbidden = false;

export const redirectToAccessForbidden = () => {
  if (isRedirectingToForbidden) return;
  isRedirectingToForbidden = true;
  setTimeout(() => {
    isRedirectingToForbidden = false;
  }, 5000);
  window.location.replace('/access-forbidden');
};

let isRedirectingToPageNotFound = false;

export const redirectToPageNotFound = () => {
  if (isRedirectingToPageNotFound) return;
  isRedirectingToPageNotFound = true;
  setTimeout(() => {
    isRedirectingToPageNotFound = false;
  }, 5000);
  window.location.replace('/page-not-found');
};

function hasCookie(cookieName: string): boolean {
  return document.cookie
    .split(';')
    .some((item) => item.trim().startsWith(cookieName + '='));
}

export const forbiddenResponseHandlerPlugin: Plugin<RootState> = (store) => {
  // Check cookie dynamically at init (not captured in a closure)
  if (!hasCookie('jaas.sid')) {
    // No cookie: redirect directly to login, skip unnecessary /logout hop
    const loginQuery = stringify({ destination: window.location.href });
    window.location.replace(
      `${process.env.VUE_APP_BACKEND_HOSTNAME}/login?${loginQuery}`
    );
  }

  store.subscribe(async (mutation) => {
    const { type } = mutation;
    if (type.endsWith('_ERROR')) {
      const error: AxiosError = mutation.payload;
      const status = _get(error, 'response.status') as number;
      const errorMessage = _get(error, 'response.data.message') as
        | string
        | undefined;
      const isForbidden = status === 403;
      const isSessionInvalid = status === 401;

      // Check cookie dynamically on each error, not from a stale closure
      if (isForbidden && hasCookie('jaas.sid')) {
        localStorage.setItem(
          'forbiddenResourceErrorMessage',
          errorMessage ?? ''
        );
        redirectToAccessForbidden();
      }

      if (isSessionInvalid) {
        redirectToLoginSignup();
      }

      // Handle 500 errors that may indicate infrastructure issues (e.g. DB down).
      // If the cookie is gone, the session is dead — redirect to login.
      if (status >= 500 && !hasCookie('jaas.sid')) {
        redirectToLoginSignup();
      }
    }
  });
};
